// extracted by mini-css-extract-plugin
export default {"root":"styles_root__bIOuq","label":"styles_label__6qoQ5","selected":"styles_selected__wL9Kx"};